import { Separator } from "../components/Separator";
import { cn } from "../lib/utils";
import React from "react";
import { Button } from "./Button";
import { Icon } from "./Icon";
export function Page({ children, variant = "normal" }) {
    const mainVariantClasses = variant === "normal" ? "s-h-full s-py-16" : "s-h-full s-py-4 s-px-2";
    const divVariantClassNames = variant === "normal" ? "s-gap-6 s-px-6" : "s-gap-4";
    return (React.createElement("main", { className: mainVariantClasses },
        React.createElement("div", { className: cn("s-mx-auto s-flex s-h-full s-max-w-4xl s-flex-col s-text-sm s-font-normal", "s-text-foreground dark:s-text-foreground-night", divVariantClassNames) }, children)));
}
Page.Header = function ({ title, description, icon }) {
    return (React.createElement(Page.Vertical, { gap: "xs" },
        React.createElement(Icon, { visual: icon, className: "s-text-primary-400 dark:s-text-primary-500", size: "lg" }),
        typeof title === "string" ? (React.createElement(Page.H, { variant: "h3" }, title)) : (React.createElement(React.Fragment, null, title)),
        description && React.createElement(Page.P, { variant: "secondary" }, description)));
};
Page.SectionHeader = function ({ title, description, action, }) {
    return (React.createElement(Page.Horizontal, { gap: "md" },
        React.createElement(Page.Vertical, { gap: "xs", sizing: "grow" },
            React.createElement(Page.H, { variant: "h5" }, title),
            React.createElement(Page.P, { variant: "secondary" }, description)),
        action && (React.createElement("div", null,
            React.createElement(Button, { ...action })))));
};
Page.Separator = function () {
    return React.createElement(Separator, null);
};
const PsizeClasses = {
    xs: "s-copy-xs",
    sm: "s-copy-sm",
    md: "s-copy-base",
    lg: "s-copy-lg",
};
Page.P = function ({ children, variant, size = "sm" }) {
    return (React.createElement("p", { className: cn(PsizeClasses[size], variant === "secondary"
            ? "s-text-muted-foreground dark:s-text-muted-foreground-night"
            : "s-text-foreground dark:s-text-foreground-night") }, children));
};
Page.H = function ({ children, variant = "h3" }) {
    const Component = variant;
    const hSizes = {
        h1: "s-heading-4xl",
        h2: "s-heading-3xl",
        h3: "s-heading-2xl",
        h4: "s-heading-xl",
        h5: "s-heading-lg",
        h6: "s-heading-base",
    };
    return (React.createElement(Component, { className: cn("s-text-foreground dark:s-text-foreground-night", hSizes[variant]) }, children));
};
const gapSizes = {
    xs: "s-gap-1",
    sm: "s-gap-2",
    md: "s-gap-3",
    lg: "s-gap-5",
    xl: "s-gap-8",
    none: "",
};
Page.Layout = function ({ children, direction = "vertical", sizing, align = "stretch", gap = "lg", }) {
    switch (direction) {
        case "horizontal":
            return (React.createElement(Page.Horizontal, { children: children, sizing: sizing, align: align, gap: gap }));
        case "vertical":
            return (React.createElement(Page.Vertical, { children: children, sizing: sizing, align: align, gap: gap }));
        case "fluid":
            return (React.createElement(Page.Fluid, { children: children, sizing: sizing, align: align, gap: gap }));
        default:
            return null;
    }
};
Page.Horizontal = function ({ children, sizing, align = "left", gap = "lg", }) {
    return (React.createElement("div", { className: cn("s-flex s-flex-col sm:s-flex-row", sizing === "grow" ? "s-grow s-basis-0" : "", sizing === "shrink" ? "s-shrink" : "", gapSizes[gap], align === "left" ? "s-justify-start" : "", align === "center" ? "s-justify-center" : "", align === "right" ? "s-justify-end" : "", align === "stretch" ? "s-justify-stretch" : "") }, children));
};
Page.Vertical = function ({ children, sizing, align = "left", gap = "md", }) {
    return (React.createElement("div", { className: cn("s-flex s-flex-col", sizing === "grow" ? "s-grow s-basis-0" : "", sizing === "shrink" ? "s-shrink" : "", gapSizes[gap], align === "left" ? "s-items-start" : "", align === "center" ? "s-items-center" : "", align === "right" ? "s-items-end" : "") }, children));
};
Page.Fluid = function ({ children, sizing, align = "stretch", gap = "xs", }) {
    return (React.createElement("div", { className: cn("s-flex s-flex-wrap", sizing === "grow" ? "s-grow" : "", sizing === "shrink" ? "s-shrink" : "", gapSizes[gap], align === "left" ? "s-items-start" : "", align === "center" ? "s-items-center" : "", align === "right" ? "s-items-end" : "") }, children));
};
//# sourceMappingURL=Page.js.map